// removed by extract-text-webpack-plugin
module.exports = {"chromePanels":"rio2016-3P0ox","panel":"rio2016-1ACm5","isCompact":"rio2016-I5-Qi","panelTop":"rio2016-3oHa4","title":"rio2016-1OqYL","aside":"rio2016-1KpAC","fixed":"rio2016-1b-e7","show":"rio2016-MJRxG"};


/*****************
 ** WEBPACK FOOTER
 ** ./styles/content.css
 ** module id = 131
 ** module chunks = 0 1 2 3 4
 **/